import { AuthenticationStateType } from "@/app/types";
import { AuthenticatedUserType, Verification } from "@/app/types/auth-types";
import { Locale } from "@/app/types/translations";
import { Factory } from "fishery";
import { branchFactory } from "./branch";

export const verificationFactory = Factory.define<Verification>(
  ({ sequence }) => ({
    telephone: "00966500000005",
    attempts: 0,
    remainingAttempts: 3,
  }),
);

export const authenticatedUserFactory = Factory.define<AuthenticatedUserType>(
  ({ sequence }) => ({
    id: 875 + sequence - 1,
    email: "john.doe@example.com",
    firstName: "John",
    lastName: "Doe",
    telephone: "00966500000005",
    rememberToken: "98aa2d03a00e404718d8189612fe274c",
    preferredLocale: "en" as Locale,
    isVerified: true,
    isIncomplete: false,
    status: "COMPLETE",
    verification: verificationFactory.build(),
    tposBranch: branchFactory.build(),
  }),
);

export const authenticationStateFactory =
  Factory.define<AuthenticationStateType>(() => ({
    authenticating: false,
    authenticatedUserData: authenticatedUserFactory.build(),
    loginUserError: undefined,
    isFcmTokenUpdated: false,
    registerUserError: undefined,
    forgotPasswordEmailSent: false,
    forgotPasswordError: undefined,
    updatingUser: false,
    updateUserError: undefined,
    smsVerificationLoading: false,
    smsVerificationError: undefined,
    otpResendLoading: false,
    otpResendError: undefined,
    remainingOtpResendAttempts: 5,
  }));
